<template>
  <div>
    <span v-if="!row" style="color: #f00;">{{ timeLoding }}</span>
    <span v-else-if="row == 'timeLoading' && timeLodingStatus != 3" style="color: #f00;">{{ timeLoding }}</span>
    <span v-else-if="row == 'endate' && timeLodingStatus != 3">{{ data.endate }}</span>
    <span v-else-if="row == 'endate' && timeLodingStatus == 3">{{ timeLoding }}</span>
  </div>
</template>
<script>
import moment from "moment-timezone";
export default {
  name: 'GamePropTimer',
  props: {
    data: Object,
    row: String,
  },
  data () {
    return {
      timeLodingStatus: 0, // 時間過期狀態
      timeLoding: null,
      timeLoop: null
    }
  },
  watch: {
    data: {
      immediate: true,
      handler (val) {
        this.runTime(val)
      }
    },
    timeLodingStatus (val) {
      this.$emit('checkTimeStatus', val)
    }
  },
  beforeDestroy () {
    clearTimeout(this.timeLoop);
  },
  methods: {
    runTime (data) {
      if (!data) return
      clearTimeout(this.timeLoop);
      this.timeLoop = setInterval(() => {
        let now = moment(moment.tz('Asia/Hong_Kong').format("YYYY-MM-DD H:mm:ss")).valueOf()
        let enTime
        const period = data.period + "" // 期數轉字串
        if (period.length !== 8) {
          enTime = moment(new Date(data.codate)).valueOf() + 1000; // 執行順序關係，與距離封盤時間同步所以 + 1秒
        } else {
          const TimeDelay = data.second ? (data.second - 9) * 1000 : 0 
          enTime = moment(new Date(data.endate)).valueOf() + TimeDelay // 延後多少結算時間 (剩餘設定時間為"開獎時間 + 結算設定時間 - 10秒")
        }
        let subTime = moment.tz(enTime - now, "Africa/Abidjan")
        if (Number(moment(data.date).format("YYYYMMDD")) > Number(moment.tz('Asia/Hong_Kong').format("YYYYMMDD"))) {
          this.timeLoding = '（跨日期数）'
          this.timeLodingStatus = 3
        } else if (moment(subTime).valueOf() <= 0) {
            this.timeLoding = '（设定时间已过）'
            this.timeLodingStatus = 2
          if (period.length !== 8) { // 日開六合彩需 當設定時間已過需顯示00:00:00
            this.$emit('timeOut')
          } 
        } else {
          this.timeLoding = this.timeText(moment(subTime.subtract(1, 'seconds')))
          this.timeLodingStatus = 1
        }
        this.$emit('trcolor', subTime <= 10000)
      }, 1000);
    },
    timeText (date) {
      const time = (val) => {
        return val < 10 ? `0${val}` : val
      }
      let rtime = ''
      const d = date.get('date')
      date.get('hours') > 0 ? rtime += `${time(date.get('hours'))}:` : ''
      rtime += `${time(date.get('minutes'))}`
      rtime += `:${time(date.get('seconds'))}`
      return rtime
    }
  }
}
</script>